// Quotes a field per RFC 4180 only when it needs it (contains a comma,
// quote, or newline); embedded quotes are doubled.
const escapeCsvField = (value) => {
  const str = value === null || value === undefined ? '' : String(value);
  return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};

// Builds a CSV in-browser and triggers a download — no library needed for
// something this small, and it keeps whatever filters/search are active on
// the page (rows are whatever the caller already has on screen).
export const downloadCsv = (filename, headers, rows) => {
  const lines = [headers, ...rows].map((row) => row.map(escapeCsvField).join(','));
  const csv = lines.join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
